import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { StyledForm } from "../../../styled/form";
import { StyledPaper } from "../../../styled/paper";

const NotificacionPlantillasFilters = ({ categories, categoria, onCategoriaChange, onSearch }) => {
    return (
        <StyledPaper.Container>
            <StyledForm.Input>
                <FormControl fullWidth>
                    <InputLabel id="categoria-filter-label">Categoría</InputLabel>
                    <Select
                        labelId="categoria-filter-label"
                        value={categoria}
                        label="Categoria"
                        onChange={(e) => onCategoriaChange(e.target.value)}
                        variant="standard"
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {categories.map((item) => (
                            <MenuItem value={item} key={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </StyledForm.Input>
            <StyledForm.ButtonContainer>
                <StyledForm.Button variant="contained" color="primary" onClick={onSearch}>
                    Buscar
                </StyledForm.Button>
            </StyledForm.ButtonContainer>
        </StyledPaper.Container>
    );
};

export default NotificacionPlantillasFilters;
